export default __webpack_public_path__ + "static/media/Generic_Frame.0508e162.png";